module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bh-0cfc56195412f09f4c705d519df5972c.svg";